<template>
  <div>
    <LoadingState
      v-if="loading"
      :loading="loading"
    />
    <v-container
      v-else
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
        class="mt-3"
      >
        <v-toolbar
          flat
          color="transparent"
          class="mb-4 mt-4"
          height="20px"
        >
          <v-btn
            icon
            class="text--secondary"
            @click="goBack"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span class="text-capitalize subheading text--secondary">
            {{ $t('Settings') }}
          </span>
        </v-toolbar>

        <v-flex
          v-if="!hasEnabledPlugin"
          class="ma-4">
          <span>{{ $t('No plugins installed or enabled') }}</span>
        </v-flex>

        <i-count-settings
          v-if="isEnabled('futureecom/icount') && configuration"
          :config="configuration"
        />

        <star-printer-settings
          v-if="isEnabled('futureecom/star-printer') && configuration"
          :config="configuration"
        />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import ICountSettings from '@/modules/Settings/components/Plugins/ICountSettings'
import StarPrinterSettings from '@/modules/Settings/components/Plugins/StarPrinterSettings'

export default {
  name: 'SettingsPlugins',
  components: {
    StarPrinterSettings,
    ICountSettings,
    LoadingState
  },

  data () {
    return {
      loading: false,
      pluginsInUse: [
        'futureecom/icount',
        'futureecom/star-printer'
      ],
      pluginsList: [],
      configuration: null
    }
  },

  computed: {
    hasEnabledPlugin () {
      if (this.pluginsList.length === 0) {
        return false
      }

      for (const name in this.pluginsList) {
        if (this.pluginsInUse.includes(name) && this.pluginsList[name].enabled) {
          return true
        }
      }

      return false
    }
  },

  async created () {
    this.pluginsList = await this.$http.make('settings').getPluginsList()
    this.configuration = await this.$http.make('settings').find('')
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'settings' })
    },

    isEnabled (name) {
      if (!this.pluginsList || this.pluginsList.length === 0) {
        return false
      }

      const plugin = this.pluginsList[name]

      if (!plugin) {
        return false
      }

      return plugin.enabled
    }
  }
}
</script>
